import { APICall } from ".."

const ControllerName = "MobRequestStatus"

export const GetStatusLookup = () => {
    return APICall("get", ControllerName + "/GetMobStatus")
}
